<div class="document-upload">
  <div class="document-type-container">
    <mat-form-field>
      <mat-label translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.TYPE_PROMPT"></mat-label>
      <mat-select name="document-type" [(ngModel)]="selectedDocumentType" (selectionChange)="onDocumentTypeChange()">
        @for (document of acceptedDocuments; track $index) {
          @if (showCustomDocuments || document.type !== 'CUSTOM_DOCUMENT') {
            <mat-option [value]="document.type">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.' + document.type | translate }}</mat-option>
          }
        }
      </mat-select>
    </mat-form-field>
  </div>
  @if (uploading) {
    <app-spinner size="medium"></app-spinner>
  } @else if (selectedDocumentType !== null) {
    <div class="file-container">
      <app-file-upload
        [type]="getUploadType(selectedDocumentType)"
        [acceptedFileTypes]="acceptedExtensions"
        [maxSize]="maxSize"
        (fileChange)="uploadInfo = $event"
      ></app-file-upload>
    </div>
    @if (uploadInfo !== null) {
      <div class="upload-button-container">
        <button mat-raised-button color="primary" (click)="onUploadClick()">{{ 'COMMON.UPLOAD' | translate }}</button>
      </div>
    }
  }
</div>
